import React from 'react';
import {
	styled,
	Form,
	FormItem,
	TextInput,
	Button
} from 'ps-gui';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';
import PhoneNumber from '../../../components/phonenumber';
import Message from '../../../blocks/message';

export default class LoginForm extends React.PureComponent {
	render() {
		const {data, setProperty, login, showForgottenPasswordForm, bankIdMatcherInfo} = this.props;


		let errorCode = null;
		if (bankIdMatcherInfo) {
			errorCode = bankIdMatcherInfo.get('errorCode');
		}

		return (
			<>
				{
					bankIdMatcherInfo && (
						<Message maxWidth="80vw">
							{
								errorCode ? (
									<p>
										{getPhrase('unmatchedBankIdLoginMessage.' + errorCode)}<br/>
										<PhoneNumber preset="intergram"/>
									</p>
								) : (
									<>
										<p>
											{getPhrase('unmatchedBankIdLoginMessage.line1')}
										</p>
										<p>
											{getPhrase('unmatchedBankIdLoginMessage.line2')}
										</p>
										<p>
											{getPhrase('unmatchedBankIdLoginMessage.line3')}
										</p>
									</>
								)
							}
						</Message>
					)
				}
				<h1>{getPhrase('loginNoun')}</h1>
				<Form vertical onAction={login} key="unamePwd">
					<FormItem label={getFormItemLabel('userName')}>
						<TextInput
							value={data.get('userName') || ''}
							onChange={value => setProperty('userName', value)}
						/>
					</FormItem>
					<FormItem label={getFormItemLabel('password')} error={data.get('loginError')}>
						<TextInput
							value={data.get('password') || ''}
							password
							onChange={value => setProperty('password', value)}
						/>
					</FormItem>
					<Button
						text={getPhrase('login')}
						onAction={login}
					/>
					<Link
						margin="16px 4px"
						onMouseDown={showForgottenPasswordForm}
					>{getPhrase('forgottenPassword')}</Link>
				</Form>
			</>
		);
	}
}

const Link = styled.div`
	color: ${props => props.theme.textColor};
	font-weight: 500;
	cursor: pointer;
	margin: ${props => props.margin};
	&:hover {
		text-decoration: underline;
	}
`;
